import { ContainerModule } from '@evertel/di'
import { ThreadController, CreateThreadController } from './controller'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(ThreadController).toSelf()
        m.bind(CreateThreadController).toSelf()
    })
]

export { DI_MODULES }
